import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {type CustomerLastRate, customerLastRateSchema} from './schemas'

export async function getCustomerLastRates(customerId: string): Promise<CustomerLastRate[]> {
    const raw = await apiFetch<unknown>(`/customers/${customerId}/last-rates`)
    return z.array(customerLastRateSchema).parse(raw)
}
